import { BrutCustomElements } from "brut-js"

import BrowseMealsPage         from "./BrowseMealsPage"
import DashboardRateMealButton from "./DashboardRateMealButton"
import DashboardRateMealDialog from "./DashboardRateMealDialog"
import FormDisable             from "./FormDisable"
import MealSearch              from "./MealSearch"
import NewPlanByDatePage       from "./NewPlanByDatePage"
import OpenDetails             from "./OpenDetails"
import PlanEditorComponent     from "./PlanEditorComponent"
import PlanUpdate              from "./PlanUpdate"
import SplitDropdown           from "./SplitDropdown"
import TonightComponent        from "./TonightComponent"


document.addEventListener("DOMContentLoaded", () => {
  BrutCustomElements.define()

  BrowseMealsPage.define()
  DashboardRateMealButton.define()
  DashboardRateMealDialog.define()
  FormDisable.define()
  MealSearch.define()
  NewPlanByDatePage.define()
  OpenDetails.define()
  PlanEditorComponent.define()
  PlanUpdate.define()
  SplitDropdown.define()
  TonightComponent.define()
})
